// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"175":"300609ab8dc0634a","631":"166f7a43fa161b7f","952":"b729385a3d8608ac"}[chunkId] + ".js";
};